import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ExampleCardComponent } from "./example/example-card.component";
import { NewTanksCardComponent } from "./newTanks/newTanks-card.component";
import { NewInstalledUnitsCountCardComponent } from "./newInstalledUnitsCount/newInstalledUnitsCount-card.component";
import { NewSilentUnitsCountCardComponent } from "./newSilentUnitsCount/newSilentUnitsCount-card.component";
import { MissedPayloadsCountCardComponent } from "./missedPayloadsCount/missedPayloadsCount-card.component";
import { DistributorsCountCardComponent } from "./distributorsCount/distributorsCount-card.component";
import { DistributorsTicketsCountCardComponent } from "./distributorsTicketsCount/distributorsTicketsCount-card.component";
import { CustomersTicketsCountCardComponent } from "./customersTicketsCount/customersTicketsCount-card.component";
import { DeletedCustomersCountCardComponent } from "./deletedCustomersCount/deletedCustomersCount-card.component";


@NgModule({
    declarations: [
        ExampleCardComponent,
        NewTanksCardComponent,
        DistributorsCountCardComponent,
        DistributorsTicketsCountCardComponent,
        CustomersTicketsCountCardComponent,
        NewInstalledUnitsCountCardComponent,
        NewSilentUnitsCountCardComponent,
        MissedPayloadsCountCardComponent,
        DeletedCustomersCountCardComponent
    ],
    imports: [
        CommonModule 
    ],
    exports: [
        ExampleCardComponent,
        NewTanksCardComponent,
        DistributorsCountCardComponent,
        DistributorsTicketsCountCardComponent,
        CustomersTicketsCountCardComponent,
        NewInstalledUnitsCountCardComponent,
        NewSilentUnitsCountCardComponent,
        MissedPayloadsCountCardComponent,
        DeletedCustomersCountCardComponent
    ]
  })
  export class CardsModule { }
